<!-- DEPRECATED -->
<script>
	import { getLocation } from "$lib/utilities/getLocation";
	import { getLocationServices } from "$lib/utilities/getLocationServices";

	import Services from "$lib/components/Services.svelte";

	export let data;
	export let lang;
	export let locationKey;
	export let servicesContentClass = "mb-6";

	$: useLocation =
		locationKey ||
		decodeURIComponent(
			data?.url?.pathname?.split("/").filter(Boolean).at(-1),
		);

	$: mainLocation = getLocation(data, useLocation);

	$: services = getLocationServices(data, mainLocation, lang);
</script>

<Services {services} {servicesContentClass} />
